import { css, mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

import { Logout } from '../../Logout'

const CommonTriggerStyles = css`
  display: flex;
  align-items: center;
`

export const StyledLink = styled.a`
  ${CommonTriggerStyles}
  text-decoration: none;
`

const centerStyles = css`
  display: flex;
  align-items: center;
`

export const LeftContent = styled.span`
  ${centerStyles}
  justify-content: center;
  margin-right: ${spacing(2)};

  svg {
    fill: ${(props) => props.theme.colors.palette.greys.darker};
    width: 24px;
    height: 24px;
  }
`

export const Content = styled.span`
  ${centerStyles}
  flex-grow: 1;
  flex-wrap: wrap;
  padding: ${spacing(1.5)} 0;
`

export const StyledAltText = styled.span`
  ${Text('xsmall', 'default')};
`

export const RightContent = styled.span`
  ${centerStyles}
  justify-content: center;
`

export const StyledGrid = styled(Grid)`
  margin: ${spacing(2)} auto;
  max-width: ${(props) => props.theme.site.siteWidth};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: ${spacing(7)} auto;
  }
`

export const NavigationContainer = styled(GridItem)<{
  mobileOnly?: boolean
}>`
  display: ${(props) => (props.mobileOnly ? 'block' : 'none')};
  margin-bottom: 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: ${(props) => (props.mobileOnly ? 'none' : 'block')};
    margin-left: ${spacing(4)};
  }
`

export const StyledGridItem = styled(GridItem)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    margin-bottom: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-right: ${spacing(4)};
    margin-bottom: ${spacing(0)};
  }
`
export const TrustPilotContainer = styled.div`
  margin-bottom: ${spacing(7)};
`

export const LiveChatWrapper = styled.div`
  display: none;
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);

  .LPMcontainer.LPMoverlay {
    display: none !important;
  }
`

export const StyledLogout = styled(Logout)`
  ${Text('bodyText', 'default')}
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${spacing(1)} 0;
  border: 0;
  text-decoration: none;

  &:hover,
  &:focus {
    width: 100%;
    padding: ${spacing(1)} 0;
    border: 0;
    text-decoration: none;
  }
`
